import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { QueryItem, QueryListResponse } from "../../types/Query";
import { ThunkConfig } from "../../types/responseType";
import QueryApis from "../../api/QueryApis";

interface QueryState {
  loading: boolean;
  data: QueryItem[];
  pagination: QueryListResponse | null;
}

const initialState: QueryState = {
  loading: false,
  data: [],
  pagination: null,
};

export const fetchQueries = createAsyncThunk<
  QueryListResponse,
  { page: number; size: number; branchCode: string },
  ThunkConfig
>("queries/fetchQueries", async ({ page, size, branchCode }, thunkAPI) => {
  const response = await QueryApis.getQueries(page, size, branchCode);
  if (!response) return thunkAPI.rejectWithValue("Unable to fetch data");
  return response.data;
});

export const querySlice = createSlice({
  name: "queries",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchQueries.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchQueries.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload.content;
        state.pagination = action.payload;
      })
      .addCase(fetchQueries.rejected, (state) => {
        state.loading = false;
      });
  },
});

export default querySlice.reducer;
